<template>
  <div class="login-message form">
    <div class="ipt-item phone">
      <customField
        v-model="form.phone"
        type="number"
        :placeholder="$t('login.phone_placeholder')"
      >
        <template slot="prev">
          <div class="country-code" @click="showZoneCodePicker = true">
            <span>+{{ form.zone_code }}</span>
          </div>
        </template>
        <template slot="next" v-if="form.phone && form.phone.length > 0">
          <div class="icon-box" @click="clearPhone"><Icon name="clear" color="#888" /></div>
        </template>
      </customField>
    </div>
    <div class="ipt-item">
      <custom-field
        :placeholder="$t('login.message_code_placeholder')"
        :maxlength="6"
        v-model="form.code"
      > 
        <template slot="next">
          <button
            :class="[
              'verCode-btn',
              isSendVerCode || !form.phone ? 'verCode-btn--disabled' : 'verCode-btn--normal'
            ]"
            :disabled="isSendVerCode || !form.phone"
            @click="handleSendVerCode"
            >
            {{
              isSendVerCode
                ? `(${verCodeTime}s)`
                : $t("login.send_message_btn_text")
            }}
          </button>
        </template>
      </custom-field>
    </div>
    <div class="agreement-box">
      <Checkbox v-model="isCheckAgreement">
        {{$t('disclaimers.aggreen')}} <span class="link" @click.stop="toDisclaimers">{{$t('disclaimers.aggereen_title')}}</span>
      </Checkbox>
    </div>
    <div class="empty"></div>
    <div class="btn-submit mb0" :class="{dis: submitDis}" @click="login">{{ $t("common.confirm") }}</div>

    <Popup v-model="showZoneCodePicker" class="picker-ui" position="bottom">
      <Picker
        show-toolbar
        :columns="zoneCodeList"
        :default-index="currentZoneCodeIndex"
        @confirm="handleConfirmZoneCode"
        @cancel="showZoneCodePicker = false"
      />
    </Popup>
  </div>
</template>

<script>
import customField from "@/components/customField/index.vue";
import { Checkbox, Popup, Picker, Toast, Icon } from "vant";
import { isChinaPhone, isHKPhone } from "@/utils/verify";
import { getBrowser } from "@/utils/browser";
import { login } from "@/utils/hybirdMethods";
import { trimPlus } from "@/utils/utils.new"
import {
  buildAreaCodePickerOptions,
  initDefaultAreaCode,
  getAreaCodePickerIndex
} from "@/utils/areaCodeList";

export default {
  components: {
    customField,
    Checkbox,
    Popup,
    Picker,
    Icon
  },
  props: {
    userInfo: {
      type: [Object, String],
      defaults: function(){
        return {}
      }
    }
  },
  watch: {
    userInfo: {
      handler(newVal){
        if(newVal.phone && newVal.zone_code){
          this.form.phone = newVal.phone;
          this.form.zone_code = newVal.zone_code;
        }
      },
      immediate: true
    }
  },
  computed: {
    submitDis(){
      return !(
        trimPlus(this.form.phone) &&
        trimPlus(this.form.code) &&
        this.isCheckAgreement
      );
    },
    zoneCodeList() {
      return buildAreaCodePickerOptions(this.$i18n);
    }
  },
  data() {
    return {
      form: {
        phone: "",
        code: "",
        zone_code: 852,
        area_code_id: "", // 新增区号ID
        login_type: 2,
        source: "app"
      },
      showZoneCodePicker: false,
      currentZoneCodeIndex: 0, // 新增：当前区号选中的索引
      isSendVerCode: false,
      verCodeTime: 120,
      isCheckAgreement: false
    };
  },
  mounted() {
    initDefaultAreaCode(this.form);
    this.currentZoneCodeIndex = getAreaCodePickerIndex(
      this.zoneCodeList,
      this.form.area_code_id
    );
  },
  methods: {
    // 手机号清除
    clearPhone(){
      this.form.phone = "";
    },
    // 手机号验证 根据地区
    verifyPhone() {
      const { zone_code, phone } = this.form;
      if(zone_code == "86"){
        return isChinaPhone(phone);
      }
      else if(zone_code == "852"){
        return isHKPhone(phone);
      }
    },
    // 点击获取验证码
    handleSendVerCode() {
      // if (!this.verifyPhone()){
      //   return this.$toast.fail(this.$t('common.phone_verify_fail_text'));
      // };
      const { phone, zone_code, area_code_id } = this.form;
      const params = {
        phone,
        zone_code,
        area_code_id, // 新增区号ID参数
        type: 1, //1登录，2注册，3找回密码
        source: "app"
      };
      this.$apis
        .sendVerCode(params)
        .then(res => {
          // 有msg则证明验证码没有发送成功 验证码发送成功在倒计时
          if( res.msg ){
            return false;
          }
          if(res.code && !res.msg){
            this.form.code = res.code;
          }
          Toast(this.$t("common.message_send_success_text"));
          this.isSendVerCode = true;
          this.setIntervalSendCode();
        })
        .catch(e => {

        });
    },
    setIntervalSendCode() {
      const now = new Date().getTime();
      const end = new Date(now + this.verCodeTime * 1000).getTime();
      this.verCodeTimer = setInterval(() => {
        this.verCodeTime = Math.ceil((end - new Date().getTime()) / 1000);
        if (this.verCodeTime <= 0) {
          clearInterval(this.verCodeTimer);
          this.verCodeTime = 120;
          this.isSendVerCode = false;
        }
      }, 1000);
    },
    handleConfirmZoneCode(e){
      this.form.zone_code = e.value;
      this.form.area_code_id = e.id; // 同时保存区号ID
      this.currentZoneCodeIndex = this.zoneCodeList.findIndex(item => item.id === e.id);
      this.showZoneCodePicker = false;
    },
    login(){
      this.form.phone = trimPlus(this.form.phone);
      this.form.code = trimPlus(this.form.code);
      if(!this.form.phone || !this.form.code || !this.isCheckAgreement) return false;
      this.$apis.authV2LoginApi(this.form).then(res => {
        if ( res.msg ) {
          this.$toast.fail(res.msg);
          return false;
        }
        const { token, user_info } = res;
        this.$setStorageApp("login_mode", 2);
        this.$localstorage.set("userInfo", user_info);
        sessionStorage.setItem("token", token);
        // 登录成功
        if (getBrowser().isApp) {
          login(res);
          } else {
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else if (this.$route.query.open == 1) {
            this.$router.push({
              path: "/open-account/home"
            });
          } else {
            this.$router.go(-1);
          }
        }
      }).catch(err => {
        // clearInterval(this.verCodeTimer);
        // this.form.code = "";
        // this.verCodeTime = 120;
        // this.isSendVerCode = false;
      });
    },
    // 免责申明
    toDisclaimers() {
      this.$router.push({
        path: "/login-disclaimers"
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "./form.comon.less";
.icon-box{
  padding: 0 20px;
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
